import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const SMECustomerSiteMapModel = {
  getSMECustomerList: () => {
    return modelBaseV2.get('/api/intf-edi/SMECustomer')
  },
  searchSMECustomerSiteMap: (params) => {
    const qs = modelBaseV2.toQueryString(params)
    return modelBaseV2.get(`/api/intf-edi/SMESiteMap?${qs}`);
  },
  postSMECustomerSiteMapAction: (body) => {
    return modelBaseV2.post('/api/intf-edi/SMESiteMapAction', { body });
  },
  downloadSMECustomerSiteMapExcel: (body) => {
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      inputUserID: "7",
      inputCountryCode: "16",
      inputUserLanguageCode: "17",
      sortBy: "24",
      sMEEdiCustomerCode: "75",
      samsungChannel: "76",
      iFChannelAttr1: "77",
      iFChannelAttr2: "78",
      isExcelDownload: "79",
      mapType: "80",
    }
    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let arg = body[key];
      return {
        code: value,
        value: arg
          ? Array.isArray(arg)
            ? arg.join('^')
            : arg.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "SME Customer Site Map"
      ],
      storedProcedureCode: "42",
      params
    }
    return modelBaseV2.postDownload('/api/executesp/export/file', { body: exportConfig }, `SME_Customer_IF_Site_Map_${moment().format('YYYYMMDDhhmm')}.xlsx`);
  }
}

export default SMECustomerSiteMapModel;  